import { useSelector, useDispatch } from "react-redux";
import { setTitle, setNavigate } from "../redux/slices/entityclonerslice";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormInput, FormCheckbox } from "../forms/form-components";
import { Loader } from "@progress/kendo-react-indicators";
import { isEmptyObject } from "../lib/utils";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const EntityCloner = (props) => {
    const {rootClassName, showNavigate, ...other} = props;

    const state = useSelector(e => e.entityCloner);

    const dispatch = useDispatch();

    const currentTheme = useSelector(e => e.currentTheme);

    const { t } = useTranslation();
    
    const formValidator = values => 
    {   
        let formErrors = {};
        
        let title = values["title"];
    
        if (!title || title.trim().length == 0)
            formErrors = Object.assign(formErrors, {title: t("entitycloner.specify")});
        else if (title.indexOf("©") >= 0)
            formErrors = Object.assign(formErrors, {title: t("entitycloner.titles")});

        if (isEmptyObject(formErrors))
            return undefined;
    
        return formErrors;    
    };


    return (
        <>
            <div className={`entity-cloner ${rootClassName}`}>
                {
                    state.processing && 
                    <div className="page-loader">
                    <Loader size={"small"} type="pulsing" themeColor={"primary"} />
                    {
                        state.processingText && 
                        <div style={{fontSize: 13, color: currentTheme.primary}}>{state.processingText}</div>
                    }
                    </div>
                }
                <Form    
                    validator={formValidator}
                    key={state.formKey}
                    initialValues={{...state.formInitialValues}}
                    render={(formRenderProps) => {
                        return (
                            <FormElement horizontal={false}
                                style={{
                                    // width: 250,
                                }}
                            >        
                                <div>
                                    <Field 
                                        autoFocus={true}
                                        id={"title"}
                                        name={"title"}
                                        label={t("entitycloner.title")}
                                        component={FormInput}
                                        onChange={ e => dispatch(setTitle(e.value))}
                                        style={{width: "100%"}}
                                        maxLength={50}/>
                                </div>
                                <div style={{marginTop:18}}>
                                {
                                    showNavigate &&
                                    <div style={{marginTop:18}}>
                                        <Field id={"navigate"} name="navigate" label={t("entitycloner.navigate")} component={FormCheckbox}
                                                onChange={ e => dispatch(setNavigate(e.target.value))}
                                        />  
                                    </div>                                  
                                }
                                </div>
                            </FormElement>
                        )
                    }}
                
            />                   
            </div>
            <style>
                {
                    `
                        .entity-cloner
                        {
                            padding: 0 8px 8px 8px;
                            width: 400px;
                        }
                    `
                }
            </style>   
        </>
    );
};

